import { Trophy, Zap } from "lucide-react";

/**
 * Shows a celebratory ribbon when the attempt beats the student's own history.
 * Renders only when at least one of is_best_wpm / is_best_accuracy is true.
 */
export default function PersonalBestBadge({ result }) {
  if (!result) return null;
  const bestWpm = !!result.is_best_wpm;
  const bestAcc = !!result.is_best_accuracy;
  if (!bestWpm && !bestAcc) return null;

  const label = bestWpm && bestAcc
    ? "New personal best — speed & accuracy!"
    : bestWpm
      ? "New personal best speed!"
      : "New personal best accuracy!";

  return (
    <div
      className="mt-6 border-2 border-brand-gold/40 bg-gradient-to-r from-[#002FA7] to-[#0A2540] text-white px-6 py-4 flex items-center justify-between gap-4 flex-wrap"
      data-testid="personal-best-badge"
    >
      <div className="flex items-center gap-4">
        <Trophy className="w-8 h-8 text-yellow-300" strokeWidth={1.5} />
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-white/70 flex items-center gap-2">
            <Zap className="w-3 h-3" /> Personal best
          </div>
          <div className="font-black tracking-tight text-lg">{label}</div>
        </div>
      </div>
      <div className="flex items-center gap-4 text-sm font-mono">
        {bestWpm && (
          <div className="text-right" data-testid="pb-wpm">
            <div className="text-[10px] uppercase tracking-widest text-white/60">WPM</div>
            <div className="text-2xl font-black">
              {result.wpm}
              <span className="text-xs text-white/60 ml-1">
                (prev {result.prev_best_wpm ?? 0})
              </span>
            </div>
          </div>
        )}
        {bestAcc && (
          <div className="text-right" data-testid="pb-accuracy">
            <div className="text-[10px] uppercase tracking-widest text-white/60">Accuracy</div>
            <div className="text-2xl font-black">
              {result.accuracy_percent}%
              <span className="text-xs text-white/60 ml-1">
                (prev {result.prev_best_accuracy ?? 0}%)
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
